import { isArray } from 'lodash';
import * as moment from 'moment/moment';

import { TicketListConstants } from '@main-application/service/service.constants';

export function filterToQueryParams(filter: object) {
  const activeFilters = Object.entries(filter)
    ?.filter(e => typeof e[1] != 'undefined' && e[1] != null)
    ?.map(e => `${e[0]}=${typeof e[1].toISOString === 'function' ? e[1].toISOString() : e[1]}`);
  return activeFilters?.length > 0 ? '?' + activeFilters.reduce((a, b) => `${a}&${b}`) : '';
}

export function convertFiltersToParams(
  filters: Record<string, any>,
  arrayFields: string[] = [],
  formatDatesToString = false
): Record<string, any> {
  const params: Record<string, any> = {};

  Object.entries(filters).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '' || (isArray(value) && !value?.length)) return;

    if (arrayFields.includes(key) && Array.isArray(value) && value.length) {
      params[key] = value.join(',');
    } else if (key === 'startDate' && formatDatesToString) {
      params[key] = moment(value).format('YYYY-MM-DD');
    } else if (key === 'endDate' && formatDatesToString) {
      params[key] = moment(value).format('YYYY-MM-DD');
    } else {
      params[key] = value.toString();
    }
  });

  return params;
}

export function extractFiltersFromParams(
  params: Record<string, any>,
  arrayFields: string[] = [],
  numberFields: string[] = [],
  dateFields: string[] = []
): Record<string, any> {
  const filters: Record<string, any> = {};

  if (params.startDate && params.endDate) {
    const start = parseLocalDate(params.startDate);
    const end = parseLocalDate(params.endDate);
    if (start && !isNaN(start.getTime()) && end && !isNaN(end.getTime())) {
      filters.timeframe = TicketListConstants.TimeFrame.Custom;
      filters.customStartDate = start;
      filters.customEndDate = end;
    }
  }

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') return;

    if (arrayFields.includes(key)) {
      const items = params[key]
        .toString()
        .split(',')
        .map((id: string) => Number(id.trim()))
        .filter((id: number) => !isNaN(id));
      if (items?.length) filters[key] = items;
    } else if (dateFields.includes(key)) {
      filters[key] = parseLocalDate(params[key]);
    } else if (numberFields.includes(key)) {
      const parsed = Number(value);
      if (!isNaN(parsed)) filters[key] = parsed;
    } else if (params[key] === 'true' || params[key] === 'false') {
      filters[key] = value === 'true';
    } else {
      filters[key] = value;
    }
  });

  return filters;
}

export function isDateString(dateStr: string): boolean {
  const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
  return regex.test(dateStr);
}

export function parseLocalDate(dateStr: string): Date {
  if (!isDateString(dateStr)) return null;
  const date = dateStr + 'T00:00:00';
  return new Date(date);
}

export function normalizeQueryParams(params: Record<string, any>, filterOut: string[] = []): Record<string, any> {
  const queryParams = { ...params };

  for (const key of filterOut) {
    delete queryParams[key];
  }

  return queryParams;
}
